import {
  Button,
  FormGroup,
  IconButton,
  InputLabel,
  OutlinedInput,
  Tooltip,
  Box,
} from "@mui/material";
import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EditOutlined, Info, MoreHoriz } from "@mui/icons-material";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { GlobalFilter } from "../../components/GlobalFilter/GlobalFilter";
import { useLists } from "../../context/listContext";
import { AntSwitch } from "../../styles/index.sty";
import { toggleOrderData } from "../../api/orders.api";
import { useAuth } from "../../context/authContext";
import { PieChart } from "react-minimal-pie-chart";
import "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import PuffLoader from "react-spinners/PuffLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const Analytics = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [doughnutChartData, setDoughnutChartData] = useState({
    // labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
    // datasets: [
    //   {
    //     label: '# of Votes',
    //     data: [12, 19, 3, 5, 2, 3],
    //     backgroundColor: [
    //       'rgba(255, 99, 132, 0.2)',
    //       'rgba(54, 162, 235, 0.2)',
    //       'rgba(255, 206, 86, 0.2)',
    //       'rgba(75, 192, 192, 0.2)',
    //       'rgba(153, 102, 255, 0.2)',
    //       'rgba(255, 159, 64, 0.2)',
    //     ],
    //     borderColor: [
    //       'rgba(255, 99, 132, 1)',
    //       'rgba(54, 162, 235, 1)',
    //       'rgba(255, 206, 86, 1)',
    //       'rgba(75, 192, 192, 1)',
    //       'rgba(153, 102, 255, 1)',
    //       'rgba(255, 159, 64, 1)',
    //     ],
    //     borderWidth: 1,
    //   },
    // ],
  });

  const [loading, setLoading] = useState(true);
  const { config } = useAuth();
  const {
    analyticsData,
    fetchAnalyticsData,
    orderAnalytics,
    fetchOrderAnalytics,
  } = useLists();
  const data = useMemo(() => analyticsData, [analyticsData]);
  const [dates, setDates] = useState({
    fromDate: new Date(),
    toDate: new Date(new Date().valueOf() + 1000 * 3600 * 24),
  });
  const [chartDoc, setChartDoc] = useState([]);
  // const chartData = [
  //   { title: "One", value: 1, color: "#FFC074" },
  //   { title: "Two", value: 2, color: "#A2D2FF" },
  //   { title: "Three", value: 3, color: "#FF9292" },
  // ];
  useEffect(() => {
    fetchAnalyticsData();
    fetchOrderAnalytics();
  }, []);
  useEffect(() => {
    if (analyticsData.length > 0) {
      setLoading(false);
    }
  }, [analyticsData]);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    if (orderAnalytics?.length > 0 && chartDoc.length === 0) {
      const testObj = {
        labels: [],
        datasets: [
          {
            label: "# of orders",
            data: [],
            backgroundColor: [],
            borderColor: [],
            borderWidth: 1,
          },
        ],
      };
      console.log(orderAnalytics);
      orderAnalytics.forEach((el, i) => {
        testObj.labels = [...testObj.labels, months[el.month]];
        testObj.datasets[0].data = [...testObj.datasets[0]?.data, el.count];
        testObj.datasets[0].backgroundColor = [
          ...testObj.datasets[0]?.backgroundColor,
          el.color,
        ];
        testObj.datasets[0].borderColor = [
          ...testObj.datasets[0]?.borderColor,
          el.color,
        ];
      });
      console.log(testObj);
      setDoughnutChartData(testObj);
      setShow(true);
      orderAnalytics?.forEach((el, i) => {
        setChartDoc((prev) => [
          ...prev,
          {
            title: months[el.month],
            value: el.count,
            color: el.color,
          },
        ]);
      });
    }
  }, [orderAnalytics]);

  useEffect(() => {}, []);

  // console.log(orderAnalytics);

  const getDateWiseData = () => {
    fetchAnalyticsData(dates);
  };
  // const columns = useMemo(
  //   () => [
  //     {
  //       Header: "Subtotal",
  //       accessor: "order_subtotal",
  //     },
  //   ],
  //   []
  // );
  const columns = useMemo(
    () => [
      {
        Header: "Status",
        accessor: "order_status",
      },
      {
        Header: "Subtotal",
        accessor: "order_subtotal",
      },
      {
        Header: "Payment Method",
        accessor: "payment_method",
      },
    ],
    []
  );

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: "Order Id",
        Header: "Order Id",
        Cell: ({ row }) => <p>...{row?.original?.order_id?.slice(-8)}</p>,
      },
      {
        id: "User Name",
        Header: "User Name",
        Cell: ({ row }) => (
          <p>
            {`${row?.original?.user?.first_name} ${row?.original?.user?.last_name}`}
          </p>
        ),
      },
      ...columns,
      {
        id: "ACTIONS",
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title="order details"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/order-details", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <Info style={{ fontSize: "2rem", color: "#0a305e" }} />
                </IconButton>
              </Tooltip>
              {/* <Tooltip
              title="order status"
              onClick={() => {
                // console.log(row.id)
                // setOrder(row.original);
                // handleOpen();
              }}
            >
              <IconButton>
                <MoreHoriz
                  style={{ fontSize: "2rem", color: "#0a305e" }}
                />
              </IconButton>
            </Tooltip> */}
            </div>
          );
        },
      },
    ]);
  };

  // const tableHooks = (hooks) => {
  //   hooks.visibleColumns.push((columns) => [
  //     {
  //       id: "Order Id",
  //       Header: "Order Id",
  //       Cell: ({ row }) => <p>...{row?.original?.order_id?.slice(-8)}</p>,
  //     },
  //     ...columns,
  //     {
  //       id: "ACTIONS",
  //       Header: "Actions",
  //       Cell: ({ row }) => {
  //         return (
  //           <div className="flex justify-center">
  //             {/* <Tooltip
  //             title="edit"
  //             onClick={() => {
  //               // console.log(row.id)
  //               navigate("/update-product-sub-category", {
  //                 state: {
  //                   data: row.original,
  //                 },
  //               });
  //             }}
  //           >
  //             <IconButton>
  //               <EditOutlined
  //                 style={{ fontSize: "2rem", color: "#0a305e" }}
  //               />
  //             </IconButton>
  //           </Tooltip> */}
  //             <Tooltip
  //               title={`${row.is_active ? "active" : "in-active"}`}
  //               onClick={() =>
  //                 toggleOrderData(
  //                   { order_id: row.original.order_id },
  //                   config,
  //                   fetchAnalyticsData
  //                 )
  //               }
  //             >
  //               <IconButton>
  //                 {" "}
  //                 <AntSwitch
  //                   checked={row.original.is_active ? true : false}
  //                   inputProps={{ "aria-label": "ant design" }}
  //                 />
  //               </IconButton>
  //             </Tooltip>
  //           </div>
  //         );
  //       },
  //     },
  //   ]);
  // };

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    tableHooks,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = tableInstance;

  return (
    <>
      {loading ? (
        <Box sx={style}>
          <PuffLoader loading={loading} size={150} />
        </Box>
      ) : (
        <>
          <div className="flex justify-between w-[95%] m-auto  mt-[5rem]">
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              setGlobalFilter={setGlobalFilter}
              globalFilter={state.globalFilter}
            />
            {/* <Button
        type="button"
        variant="contained"
        // onClick={handleOpen}
        onClick={() => navigate('/add-product-sub-category')}
      >
        Add New
      </Button> */}
            <div className="w-[25%] flex flex-wrap">
              <div className="w-[100%] flex justify-between">
                <FormGroup>
                  <InputLabel htmlFor="fromDate">From Date: </InputLabel>
                  <OutlinedInput
                    id="fromDate"
                    name="fromDate"
                    value={dates.fromDate}
                    type="date"
                    onChange={(e) => {
                      console.log("====from date", e.target.value);
                      setDates((prev) => ({
                        ...prev,
                        fromDate: e.target.value,
                      }));
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <InputLabel htmlFor="toDate">To Date: </InputLabel>
                  <OutlinedInput
                    id="toDate"
                    name="toDate"
                    value={dates.toDate}
                    type="date"
                    onChange={(e) => {
                      console.log("====to date", e.target.value);
                      setDates((prev) => ({ ...prev, toDate: e.target.value }));
                    }}
                  />
                </FormGroup>
              </div>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  mt: "1rem",
                }}
                onClick={getDateWiseData}
              >
                Filter
              </Button>
            </div>
          </div>
          {/* <div className="w-[20%]">
        <h1>Month-wise</h1>
        <PieChart
          animate
          animationDuration={40}
          animationEasing="ease-in"
          center={[50, 50]}
          data={chartDoc}
          lineWidth={15}
          lengthAngle={360}
          paddingAngle={0}
          radius={50}
          rounded
          startAngle={0}
          viewBoxSize={[100, 100]}
          labelStyle={{
            fontSize: "6px",
            fontColor: "FFFFFA",
            fontWeight: "500",
            fontFamily: "monospace",
          }}
          label={(data) => data.dataEntry.title}
          labelPosition={70}
        />
        <div className="flex">
          {
            chartDoc?.length > 0 && chartDoc?.map((el, i) => {
              return <p key={i}><span className={`w-[0.5rem] h-[0.5rem] bg-[${el?.color}] rounded`}></span> {el?.title} - {el?.value} || &nbsp;</p>
            })
          }
        </div>
      </div> */}
          {show && (
            <div className="w-[20%]">
              <p className="text-center">Monthly Order Report</p>
              <Doughnut data={doughnutChartData} />
            </div>
          )}
          <table {...getTableProps()} className="w-[95%] m-auto mt-10">
            <thead>
              {
                // Loop over the header rows
                headerGroups.map((headerGroup) => (
                  // Apply the header row props
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {
                      // Loop over the headers in each row
                      headerGroup.headers.map((column) => (
                        // Apply the header cell props
                        <th
                          {...column.getHeaderProps()}
                          className="border-4 p-3 bg-[#1976d2] text-white"
                        >
                          {
                            // Render the header
                            column.render("Header")
                          }
                        </th>
                      ))
                    }
                  </tr>
                ))
              }
            </thead>
            {/* Apply the table body props */}
            <tbody {...getTableBodyProps()}>
              {
                // Loop over the table rows
                rows.map((row, index) => {
                  // Prepare the row for display
                  prepareRow(row);
                  return (
                    // Apply the row props
                    <tr {...row.getRowProps()}>
                      {
                        // Loop over the rows cells
                        row.cells.map((cell) => {
                          // Apply the cell props
                          return (
                            //  <td {...cell.getCellProps()} className={`p-5 border-1px bg-blue-300 cursor-pointer`}>
                            <td
                              {...cell.getCellProps()}
                              className={`p-5 border-1px bg-${
                                index % 2 === 0 ? "white" : "blue-300"
                              } cursor-pointer text-center`}
                              style={{
                                background: !row.original.is_active
                                  ? "#b3b3b3"
                                  : null,
                              }}
                            >
                              {
                                // Render the cell contents
                                cell.render("Cell")
                              }
                            </td>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </>
      )}
    </>
  );
};
